import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'bg', label: 'BG', fullLabel: 'Български', flagUrl: 'https://flagcdn.com/w40/bg.png' },
  { code: 'en', label: 'EN', fullLabel: 'English',   flagUrl: 'https://flagcdn.com/w40/gb.png' },
  { code: 'ru', label: 'RU', fullLabel: 'Русский',   flagUrl: 'https://flagcdn.com/w40/ru.png' },
];

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  useEffect(() => {
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, []);

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
   <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        className={compact ? 'hdr-ctl hdr-lang' : undefined}
        style={
          compact
            ? undefined
            : {
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                padding: '7px 12px',
                borderRadius: '50px',
                background: 'rgba(255,255,255,0.6)',
                backdropFilter: 'blur(12px)',
                border: '1.5px solid rgba(195,222,221,0.55)',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: '700',
                color: '#2a2420',
                transition: 'all 0.15s',
                whiteSpace: 'nowrap',
              }
        }
        onMouseEnter={(e) => {
          if (!compact) e.currentTarget.style.background = 'rgba(255,255,255,0.85)';
        }}
        onMouseLeave={(e) => {
          if (!compact) e.currentTarget.style.background = 'rgba(255,255,255,0.6)';
        }}
        aria-label="Select language"
        aria-expanded={open}
      >
  <img
          src={current.flagUrl}
          alt={current.label}
          width={compact ? 26 : 20}
          height={compact ? 18 : 14}
          style={{
            width: compact ? '26px' : '20px',
            height: compact ? '18px' : '14px',
            borderRadius: compact ? '4px' : '2px',
            objectFit: 'cover',
            display: 'block',
            flexShrink: 0,
          }}
        />
        {!compact && <span>{current.label}</span>}
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          style={{
            flexShrink: 0,
           transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s',
            color: compact ? 'rgba(42,36,32,0.55)' : '#8a8a8a',
          }}
        >
          <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            right: 0,
          background: 'rgba(255,255,255,0.96)',
            WebkitBackdropFilter: 'blur(18px) saturate(150%)',
            backdropFilter: 'blur(18px) saturate(150%)',
            borderRadius: '14px',
            boxShadow: '0 12px 36px rgba(24,38,45,0.16)',
            border: '1px solid rgba(195,222,221,0.7)',
            overflow: 'hidden',
            minWidth: '164px',
            padding: '5px',
            zIndex: 9999,
          }}
        >
          {LANGUAGES.map((lang) => {
            const isActive = lang.code === i18n.language;
            return (
              <button
                key={lang.code}
                onClick={() => handleSelect(lang.code)}
              style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '11px',
                  width: '100%',
                  padding: '9px 12px',
                  borderRadius: '10px',
                 background: isActive ? 'rgba(30,104,120,0.10)' : 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontSize: '13px',
                  fontWeight: isActive ? '700' : '500',
                  color: isActive ? '#1e6878' : '#2a2420',
                  transition: 'background 0.12s, color 0.12s',
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.currentTarget.style.background = 'rgba(0,0,0,0.045)';
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.currentTarget.style.background = 'transparent';
                }}
              >
                <img
                  src={lang.flagUrl}
                  alt={lang.label}
                  width={26}
                  height={18}
                  style={{ width: '26px', height: '18px', borderRadius: '4px', objectFit: 'cover', display: 'block', flexShrink: 0 }}
                />
                <span>{lang.fullLabel}</span>
                {isActive && (
                  <span style={{ marginLeft: 'auto', color: '#1e6878', fontSize: '11px' }}>✓</span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
